import Velocity from "velocity-animate"; // eslint-disable-line
import initTab from '../../scripts/initTab';
import { getQueryParameterByName } from '../../utils'

export default {
    data() {
        return {
            clientType: 'not-client',
            currentTab: 'first',
            conditionTab: 'first'
        }
    },
	methods: {
        // отдельный метод нужен для вызова с php-шаблонов
        changeTab(name) {
            this.currentTab = name;
        },
		anchorScroll(elemId) {
            setTimeout(() => {
                const el = document.getElementById(elemId);
                if (!el) return;

                const offset = this.$store?.getters?.['app/mainTopOffsetScrolled'] ?? 0;

                Velocity(
                    el,
                    'scroll',
                    {
                        duration: 800,
                        offset: -offset,
                    },
                );
            }, 1000)
		},
        openNoReferrerLink(link, target = '_self') {
            window.open(link, target, ['noopener,noreferrer']).opener = null;
        }
	},
	mounted() {
        if (location.hash) {
            this.$nextTick(() => {
                this.anchorScroll(location.hash.slice(1));
            })
        }

        // выбирает таб
        if (getQueryParameterByName('tab')) {
            this.changeTab(getQueryParameterByName('tab'))
        }
        // скроллит к указанному блоку по id
        if (getQueryParameterByName('to')) {
            this.anchorScroll(getQueryParameterByName('to'));
        }

        initTab();
	}
}
